<template>
  <section>
    <div>
      <b-modal
        :active="isModalNewEditProcessActive"
        aria-modal
        has-modal-card
        :destroy-on-hide="true"
        aria-role="dialog"
        width="100%"
        :can-cancel="['escape']"
      >
        <template>
          <ModalNewEditProcess
            modal-cancel="true"
            :update="updateProcess"
            :create="false"
            :proceed="proceedProcess"
            :processIdSelected="selectedProcessId"
            @close="
              isModalNewEditProcessActive = false;
              updateProcess = false;
              proceedProcess = false;
            "
            @refresh="setProcess()"
            @refreshProcess="refreshProcess"
          />
        </template>
      </b-modal>
    </div>

    <div class="container box mt-5">
      <div class="content mb-6 has-text-centered">
        <h1>Proceso de Evaluación Académica {{ year }}</h1>
        <h3 v-if="showFromUnit" class="mt-0">
          {{ unit.name }}
        </h3>
        <h3 class="mt-0">Fase Actual: {{ lastPhaseProcessName }}</h3>
        <div v-if="!(showFromUnit || showFromFaculty)" class="columns centered">
          <div class="column has-text-right">
            <b-button
              v-if="
                isProcessActive &&
                isAuthorized('PerformancePhaseUpdateProcessDates')
              "
              label="Editar Fase"
              type="is-warning"
              icon-left="edit"
              @click="
                isModalNewEditProcessActive = true;
                updateProcess = true;
              "
              @refresh="setProcess()"
            />
            <b-button
              v-if="
                isProcessActive &&
                isAuthorized('PerformancePhaseAdvanceProcess')
              "
              label="Avanzar Fase"
              icon-left="forward"
              @click="
                isModalNewEditProcessActive = true;
                proceedProcess = true;
              "
              @refresh="setProcess()"
            />
          </div>
        </div>
        <!--        <div class="columns">-->
        <!--          <div class="column has-text-right">-->
        <!--            <b-button-->
        <!--              :label="`Exportación de Datos`"-->
        <!--              icon-left="file-excel"-->
        <!--              type="is-info"-->
        <!--              tag="a"-->
        <!--              :href="'/performances/statistics-menu/' + year"-->
        <!--            />-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div class="columns">
          <div class="column has-text-right">
            <b-button
                :label="`Ir a Dasboard de Datos`"
                icon-left="chart-pie"
                type="is-primary"
                tag="a"
                :href="'/performances/dashboard-performance/' + year"
            />
          </div>
        </div>-->
      </div>

      <div v-if="false" class="columns">
        <div class="column has-text-right">
          <b-button
            v-if="false"
            label="Ampliar Plazo de Declaración"
            type="is-purple-color-usach"
            icon-left="users-cog"
            tag="a"
            href="/extend_phase_terms"
            target="_blank"
          />
          <b-button
            v-if="false"
            label="Reportería de la Última Fase"
            type="is-primary"
            outlined
          />
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-10 is-bordered-grey">
          <div class="columns mb-0">
            <div class="column">
              <div class="title is-5 has-text-centered">
                Fases de este Proceso
                <hr class="dropdown-divider" aria-role="menuitem" />
              </div>
            </div>
          </div>
          <b-table :data="data" striped>
            <b-table-column label="Fase" field="alt_name" v-slot="props">
              {{ props.row.alt_name }}
            </b-table-column>

            <b-table-column
              label="Fecha Inicio"
              field="start_date"
              v-slot="props"
            >
              {{
                props.row.is_started
                  ? new Date(props.row.start_date).toLocaleDateString("es-CL")
                  : "No Iniciada"
              }}
            </b-table-column>

            <b-table-column
              label="Fecha Término"
              field="end_date"
              v-slot="props"
            >
              {{
                props.row.is_started
                  ? new Date(props.row.end_date).toLocaleDateString("es-CL")
                  : "No Iniciada"
              }}
            </b-table-column>
          </b-table>
        </div>
      </div>

      <br />
      <br />

      <div class="columns">
        <div class="column">
          <div class="title is-4 has-text-centered">
            Evaluación Académica del Cuerpo Académico
            <hr class="dropdown-divider" aria-role="menuitem" />
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="title is-5">
            Filtros de Búsqueda
            <hr class="dropdown-divider" aria-role="menuitem" />
          </div>
        </div>
      </div>

      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(checkFilter)">
          <div class="columns mb-0">
            <ValidationProvider
              v-if="!showFromUnit"
              class="column"
              name="Unidad"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Unidad "
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <multiselect
                  v-model="filter.unit_id"
                  :options="units.map((type) => type.id)"
                  :custom-label="(opt) => units.find((x) => x.id === opt).name"
                  placeholder="Seleccione una Unidad"
                  selectLabel="Presione para seleccionar"
                  selectedLabel="Seleccionado"
                  deselectLabel="Presione para deseleccionar"
                  allow-empty
                >
                  <template v-slot:noOptions> No existen datos </template>
                  <span slot="noResult"> No se encontraron elementos. </span>
                </multiselect>
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              v-if="!showFromUnit"
              class="column is-2"
              name="Centro de Costo"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Centro de Costo "
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input
                  v-model="filter.cost_center"
                  placeholder="Ingrese Centro de Costo"
                  type="number"
                  maxlength="5"
                />
              </b-field>
            </ValidationProvider>

            <div :class="showFromUnit ? 'column' : 'column is-3'">
              <b-field label="RUN">
                <ValidationProvider
                  name="RUT"
                  rules="integer|min:7|max:8"
                  v-slot="{ errors }"
                >
                  <b-input v-model="filter.rut" placeholder="Ej: 12345678" />
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>

            <div :class="showFromUnit ? 'column' : 'column is-2'">
              <b-field label="DV">
                <ValidationProvider
                  name="DV"
                  rules="min:1|max:1"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="filter.dv"
                    placeholder="Ej: 1 o K"
                    maxlength="1"
                  />
                  <span>{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <ValidationProvider
              class="column"
              name="Primer Apellido"
              rules="min:3|max:255"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Primer Apellido"
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input v-model="filter.last_name" placeholder="Ej: Solis" />
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              class="column"
              name="Segundo Apellido"
              rules="min:3|max:255"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Segundo Apellido"
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input
                  v-model="filter.second_surname"
                  placeholder="Ej: Dominguez"
                />
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              class="column"
              name="Nombres"
              rules="min:3|max:255"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Nombre"
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input
                  v-model="filter.name"
                  placeholder="Ej: Felipe Cristian"
                />
              </b-field>
            </ValidationProvider>
          </div>

          <div class="columns">
            <div class="column has-text-right">
              <b-button
                v-if="haveFilters"
                label="Limpiar Filtros"
                icon-left="broom"
                type="is-warning is-light"
                @click="cleanFilters()"
              />
              <b-button
                label="Aplicar Filtros"
                icon-left="search"
                type="is-blue-color"
                @click="checkFilter()"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>

      <br />
      <br />

      <div v-if="isActiveFilter" class="columns">
        <div class="column">
          <div class="title is-5">
            Listado de las Declaraciones de desempeño del Cuerpo Académico
            <hr class="dropdown-divider" aria-role="menuitem" />
          </div>
        </div>
      </div>

      <b-tabs
        v-model="filterBy"
        v-if="isActiveFilter"
        type="is-toggle"
        position="is-centered"
      >
        <b-tab-item label="Declaraciones Aceptadas" value="ACEPTADA" />
        <b-tab-item label="Declaraciones Emitidas" value="EMITIDA" />
        <b-tab-item label="Declaraciones Devueltas" value="DEVUELTA" />
        <b-tab-item label="Declaraciones En Curso" value="EN CURSO" />
        <b-tab-item label="Declaraciones No Iniciadas" value="notStarted" />
        <b-tab-item label="No Participa en el Proceso" value="canParticipate" />
      </b-tabs>
      <b-table
        :data="filterAcademicPerformances"
        striped
        paginated
        per-page="10"
        :pagination-simple="false"
        pagination-position="bottom"
        aria-next-label="Siguiente"
        aria-previous-label="Anterior"
        aria-page-label="Página"
        aria-current-label="Página actual"
      >
        <b-table-column label="Nombre" field="academic_name" v-slot="props">
          {{ props.row.academic_name }}
        </b-table-column>

        <b-table-column label="Rut" field="academic_rut" v-slot="props">
          {{ props.row.academic_rut }}
        </b-table-column>

        <b-table-column
          :visible="!showFromUnit"
          label="Unidad"
          field="academic_unit_name"
          v-slot="props"
        >
          {{ props.row.academic_unit_name }}
        </b-table-column>

        <b-table-column
          :visible="!showFromUnit"
          label="CC"
          field="academic_unit_cost_center"
          v-slot="props"
        >
          {{ props.row.academic_unit_cost_center }}
        </b-table-column>

        <b-table-column
          label="Última Fase Ingresada"
          field="last_phase_alt_name"
          v-slot="props"
          :visible="filterBy !== 'canParticipate'"
        >
          {{ props.row.last_phase_alt_name }}
        </b-table-column>

        <b-table-column
          label="Función"
          field="function"
          v-slot="props"
          :visible="filterBy == 'canParticipate'"
        >
          {{ props.row.function ? props.row.function : "Académica/o" }}
        </b-table-column>

        <b-table-column
          label="Acciones"
          width="100"
          v-slot="props"
          :visible="filterBy !== 'canParticipate'"
        >
          <b-button
            type="is-primary"
            icon-left="eye"
            tag="a"
            :href="`/performances/process/${year}/person/${props.row.academic_id}`"
          />
        </b-table-column>

        <template slot="empty" slot-scope="props">
          <div class="columns is-centered">
            <div class="column is-6 is-centered has-text-centered">
              <b-message type="is-warning">
                No se han encontrado registros de Desempeños.
              </b-message>
            </div>
          </div>
        </template>
      </b-table>

      <b-loading v-model="isLoading" />
    </div>
  </section>
</template>

<script>
import moment from "moment";
import axios from "axios";
import ModalNewEditProcess from "./ModalNewEditProcess.vue";
import { filter } from "lodash";
export default {
  name: "ShowProcess",

  components: {
    ModalNewEditProcess,
  },

  computed: {
    filterAcademicPerformances() {
      if (!this.academicPerformances) {
        return [];
      }
      if (this.filterBy === "notStarted") {
        return this.academicPerformances.filter(
          (x) =>
            !x.is_emit &&
            !x.is_performance_declaration_in_last_phase &&
            x.can_participate
        );
      } else if (this.filterBy === "canParticipate") {
        return this.academicPerformances.filter((x) => !x.can_participate);
      }
      return this.academicPerformances.filter(
        (x) => x.state === this.filterBy || x.state === "SIN ESTADO"
      );
    },
  },

  props: {
    year: {
      type: Number,
      required: true,
    },
    last_phase: {
      type: String,
      required: true,
    },
    permissions: {
      type: Array,
      required: false,
    },
    showFromUnit: {
      type: Boolean,
      required: false,
      default: false,
    },
    unit: {
      type: Object,
      required: false,
    },
    showFromFaculty: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      //Auxiliar variables
      isLoading: false,
      isModalNewEditProcessActive: false,
      selectedProcessId: null,
      isProcessActive: false,
      updateProcess: false,
      proceedProcess: false,
      isActiveFilter: false,
      haveFilters: false,

      //Data for table
      data: [],

      //Data from API
      process: [],
      units: [],
      phases_types: [],
      academicPerformances: [],
      lastPhaseProcessName: null,

      //Filters
      filter: {
        unit_id: null,
        cost_center: null,
        run: null,
        dv: null,
        last_name: null,
        second_surname: null,
        name: null,
      },
      filterBy: "ACEPTADA",
    };
  },
  async created() {
    this.lastPhaseProcessName = this.last_phase;
    await this.setProcess();
    if (!this.showFromUnit) await this.getUnits();
    await this.getAcademicPerformances();
  },
  methods: {
    isAuthorized(name) {
      let permission = this.permissions.find((obj) => obj.name === name);
      if (permission !== undefined) {
        return permission.value;
      } else {
        return false;
      }
    },

    async getProcess() {
      this.isLoading = true;
      await axios
        .get("/performance_phases/process/" + this.year + ".json")
        .then((response) => {
          this.process = response.data;
          this.process.forEach((element) => {
            element.start_date = moment(element.start_date, [
              "YYYY-MM-DD",
              "DD-MM-YYYY",
            ]);
            element.end_date = moment(element.end_date, [
              "YYYY-MM-DD",
              "DD-MM-YYYY",
            ]);
          });
          this.lastPhaseProcessName =
            this.process[this.process.length - 1].phase_d_type.alt_name;
          this.isProcessActive = this.process.length < 4;
          this.selectedProcessId = this.process.slice(-1)[0].id;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getTypePhases() {
      this.isLoading = true;
      await axios
        .get("/phase_d_types.json")
        .then((response) => {
          this.phases_types = response.data;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
          this.$emit("close");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async setProcess() {
      this.data = [];
      await this.getProcess();
      await this.getTypePhases();

      this.phases_types.forEach((element) => {
        let phase = this.process.find((x) => x.phase_d_type.id === element.id);

        element.start_date = phase ? phase.start_date : null;
        element.end_date = phase ? phase.end_date : null;
        element.is_started = phase ? true : false;

        this.data.push(element);
      });
    },

    refreshProcess(process) {
      this.phases_types.forEach((element) => {
        if (element.id === process.phase_d_type_id) {
          element.start_date = moment(process.start_date, [
            "YYYY-MM-DD",
            "DD-MM-YYYY",
          ]);
          element.end_date = moment(process.end_date, [
            "YYYY-MM-DD",
            "DD-MM-YYYY",
          ]);
          return;
        }
      });
    },

    async getUnits() {
      this.isLoading = true;
      await axios
        .get("/units/get-departments-of-engineering-faculty.json")
        .then((response) => {
          this.units = response.data;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async checkFilter() {
      let valid = await this.$refs.observer.validate();
      if (!valid) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Algunos campos presentan errores.",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      }

      this.haveFilters = !Object.values(this.filter).every(
        (value) => value === null
      );

      await this.getAcademicPerformances();
    },

    async cleanFilters() {
      this.filter = {
        unit_id: null,
        cost_center: null,
        run: null,
        dv: null,
        last_name: null,
        second_surname: null,
        name: null,
      };
      this.haveFilters = false;
      await this.getAcademicPerformances();
    },

    async getAcademicPerformances() {
      this.isLoading = true;
      if (this.showFromUnit) this.filter.unit_id = this.unit.id;
      await axios
        .get("/performances/get-by-academic-filters.json", {
          params: {
            process_year: this.year,
            ...this.filter,
          },
        })
        .then((response) => {
          this.academicPerformances = response.data;
          this.isActiveFilter = true;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          if (this.showFromUnit) this.filter.unit_id = null;
          this.isLoading = false;
        });
    },
  },
};
</script>
